<template>



        <div v-if="typeof salary != 'undefined'">

            <!-- Платежная ведомость -->
            <b-modal header-bg-variant="primary" header-text-variant="white" scrollable
                     v-if="typeof salary.data.list != 'undefined'" size="xl" id="modal-salary-paysheet" centered
                     ok-disabled
                     title="Платежная ведомость"
                     cancel-title-html="Закрыть" button-size="sm">
                <Paysheet :list="salary.data.list" :year="salary.year" :month="salary.month" :org="org"></Paysheet>
                <template v-slot:modal-footer="{cancel}">
                    <b-button variant="primary" size="sm" @click="Print('printBodyPaysheet', 'portrait')"><span
                            class="mdi mdi-printer"></span> Печать
                    </b-button>
                    <b-button variant="secondary" size="sm" @click="cancel()"><span class="mdi mdi-close"></span> Закрыть
                    </b-button>
                </template>
            </b-modal>

            <!-- Расчетная ведомость -->
            <b-modal header-bg-variant="primary" header-text-variant="white" scrollable
                     v-if="typeof salary.data.list_rv != 'undefined'" size="xl" id="modal-salary-rv" centered
                     ok-disabled
                     title="Расчетная ведомость"
                     cancel-title-html="Закрыть" button-size="sm">

                <div class="card mb-1 sticky-top shadow-sm">
                    <div class="card-header bg-secondary text-white">Поля ведомости</div>
                    <div class="card-body">
                        <div class="form-inline">
                            <b-form-checkbox class="mr-2" v-model="fields.month" value="1" unchecked-value="0">Месяц
                            </b-form-checkbox>
                            <b-form-checkbox class="mr-2" v-model="fields.workername" value="1" unchecked-value="0" disabled>Работник
                            </b-form-checkbox>
                            <b-form-checkbox class="mr-2" v-model="fields.workerfunction" value="1" unchecked-value="0">Должность</b-form-checkbox>
                            <b-form-checkbox class="mr-2" v-model="fields.iin" value="1" unchecked-value="0">ИИН</b-form-checkbox>
                            <b-form-checkbox class="mr-2" v-model="fields.dh" value="1" unchecked-value="0">Дни/часы</b-form-checkbox>
                            <b-form-checkbox class="mr-2" v-model="fields.sum" value="1" unchecked-value="0">Начисление
                            </b-form-checkbox>
                            <b-form-checkbox class="mr-2" v-model="fields.deduction" value="1" unchecked-value="0">Удержание
                            </b-form-checkbox>
                            <b-form-checkbox class="mr-2" v-model="fields.worker" value="1" unchecked-value="0">К выплате
                            </b-form-checkbox>
                            <b-form-checkbox class="mr-2" v-model="fields.recoupment" value="1" unchecked-value="0">Вычеты
                            </b-form-checkbox>
                            <b-form-checkbox class="mr-2" v-model="fields.adjustment" value="1" unchecked-value="0">Корректировка
                            </b-form-checkbox>
                            <b-form-checkbox class="mr-2" v-model="fields.opv" value="1" unchecked-value="0">ОПВ</b-form-checkbox>
                            <b-form-checkbox class="mr-2" v-model="fields.opvr" value="1" unchecked-value="0">ОПВР</b-form-checkbox>
                            <b-form-checkbox class="mr-2" v-model="fields.oppv" value="1" unchecked-value="0">ОППВ</b-form-checkbox>
                            <b-form-checkbox class="mr-2" v-model="fields.ipn" value="1" unchecked-value="0">ИПН</b-form-checkbox>
                            <b-form-checkbox class="mr-2" v-model="fields.sn" value="1" unchecked-value="0">СН</b-form-checkbox>
                            <b-form-checkbox class="mr-2" v-model="fields.so" value="1" unchecked-value="0">СО</b-form-checkbox>
                            <b-form-checkbox class="mr-2" v-model="fields.oosms" value="1" unchecked-value="0">ООСМС</b-form-checkbox>
                            <b-form-checkbox class="mr-2" v-model="fields.vosms" value="1" unchecked-value="0">ВОСМС</b-form-checkbox>
                            <b-form-checkbox class="mr-2" v-model="fields.taxable" value="1" unchecked-value="0">Показывать облагаемый
                                доход
                            </b-form-checkbox>
                            <b-form-checkbox class="mr-5" v-model="fields.amount" value="1" unchecked-value="0"><strong>Итоги</strong>
                            </b-form-checkbox>
                            |
                            <b-form-checkbox class="ml-5" v-model="fields.merge" value="1" unchecked-value="0">Объединить начисления по
                                сотруднику
                            </b-form-checkbox>
                        </div>
                    </div>
                </div>


                <Salarysheet :list="salary.data.list_rv" :fields="fields" :year="salary.year" :month="salary.month"
                             :org="org"></Salarysheet>
                <template v-slot:modal-footer="{cancel}">

                    <b-button variant="primary" size="sm" @click="Print('printBodyRV', 'landscape')"><span class="mdi mdi-printer"></span>
                        Печать
                    </b-button>
                    <download-excel class="btn btn-sm btn-secondary mr-1" :data="salary.data.list_rv" :fields="excel.fields"
                                    worksheet="Данные по зарплате" name="Данные по зарплате.xls"><span class="mdi mdi-file-excel"></span>
                        Выгрузить в Excel
                    </download-excel>

                    <b-button variant="secondary" size="sm" @click="cancel()"><span class="mdi mdi-close"></span> Закрыть
                    </b-button>
                </template>
            </b-modal>

            <!-- Редактирование расчета -->
            <b-modal header-bg-variant="primary" header-text-variant="white" v-if="typeof salary.data.current != 'undefined'"
                     size="xl" id="modal-salary" centered ok-disabled
                     :title="'Зарплата сотрудника ' + salary.data.current.first_name + ' ' + salary.data.current.last_name"
                     cancel-title-html="Закрыть" button-size="sm">

                <input type="hidden" v-model="salary.data.current.id">
                <div class="row">
                    <div class="col-md-4">
                        <h5>Зарплата</h5>
                        <table class="table table-bordered table-sm">
                            <tbody>
                            <tr>
                                <th>Наименование</th>
                                <th>Сумма</th>
                            </tr>
                            <tr>
                                <td>Оклад</td>
                                <td>
                                    <b-form-input size="sm" type="number"
                                                  v-model="salary.data.current.res_sum"></b-form-input>
                                </td>
                            </tr>
                            <tr>
                                <td>На руки</td>
                                <td>
                                    <b-form-input size="sm" type="number"
                                                  v-model="salary.data.current.res_worker"></b-form-input>
                                </td>
                            </tr>
                            <tr>
                                <td>Работодатель</td>
                                <td>
                                    <b-form-input size="sm" type="number"
                                                  v-model="salary.data.current.res_employer"></b-form-input>
                                </td>
                            </tr>
                            <tr>
                            <tr>
                                <td>Экологическая надбавка</td>
                                <td>
                                    <b-form-input size="sm" type="number"
                                                  v-model="salary.data.current.res_ecology"></b-form-input>
                                </td>
                            </tr>
                            <tr>
                                <td>Удержание</td>
                                <td>
                                    <b-form-input size="sm" type="number"
                                                  v-model="salary.data.current.res_deduction"></b-form-input>
                                </td>
                            </tr>
                            <tr>
                                <td>Профсоюзные взносы</td>
                                <td>
                                    <b-form-input size="sm" type="number"
                                                  v-model="salary.data.current.res_ud"></b-form-input>
                                </td>
                            </tr>
                            <tr>
                                <td>Корректировка 90%</td>
                                <td>
                                    <b-form-input size="sm" type="number"
                                                  v-model="salary.data.current.res_adjustment"></b-form-input>
                                </td>
                            </tr>
                            </tbody>
                        </table>


                    </div>
                    <div class="col-md-8">
                        <h5>Налоги</h5>
                        <table class="table table-bordered table-sm">
                            <tbody>
                            <tr>
                                <th>Наименование</th>
                                <th>Облагаемая сумма</th>
                                <th>Сумма налога</th>
                            </tr>
                            <tr>
                                <td>Индивидуальный подоходный налог</td>
                                <td>
                                    <b-form-input size="sm" type="number"
                                                  v-model="salary.data.current.res_ipntaxable"></b-form-input>
                                </td>
                                <td>
                                    <b-form-input size="sm" type="number"
                                                  v-model="salary.data.current.res_ipn"></b-form-input>
                                </td>
                            </tr>
                            <tr>
                                <td>Обязательные пенсионные взносы</td>
                                <td>
                                    <b-form-input size="sm" type="number"
                                                  v-model="salary.data.current.res_opvtaxable"></b-form-input>
                                </td>
                                <td>
                                    <b-form-input size="sm" type="number"
                                                  v-model="salary.data.current.res_opv"></b-form-input>
                                </td>
                            </tr>

                            <tr>
                              <td>Обязательные пенсионные взносы работодателя</td>
                              <td>
                                <b-form-input size="sm" type="number"
                                              v-model="salary.data.current.res_opvrtaxable"></b-form-input>
                              </td>
                              <td>
                                <b-form-input size="sm" type="number"
                                              v-model="salary.data.current.res_opvr"></b-form-input>
                              </td>
                            </tr>
                            <tr>
                                <td>Обязательные профессиональные пенсионные взносы</td>
                                <td>
                                    <b-form-input size="sm" type="number"
                                                  v-model="salary.data.current.res_oppvtaxable"></b-form-input>
                                </td>
                                <td>
                                    <b-form-input size="sm" type="number"
                                                  v-model="salary.data.current.res_oppv"></b-form-input>
                                </td>
                            </tr>
                            <tr>
                                <td>Социальный налог</td>
                                <td>
                                    <b-form-input size="sm" type="number"
                                                  v-model="salary.data.current.res_sntaxable"></b-form-input>
                                </td>
                                <td>
                                    <b-form-input size="sm" type="number"
                                                  v-model="salary.data.current.res_sn"></b-form-input>
                                </td>
                            </tr>
                            <tr>
                                <td>Социальные отчисления</td>
                                <td>
                                    <b-form-input size="sm" type="number"
                                                  v-model="salary.data.current.res_sotaxable"></b-form-input>
                                </td>
                                <td>
                                    <b-form-input size="sm" type="number"
                                                  v-model="salary.data.current.res_so"></b-form-input>
                                </td>
                            </tr>
                            <tr>
                                <td>Отчисления ОСМС</td>
                                <td>
                                    <b-form-input size="sm" type="number"
                                                  v-model="salary.data.current.res_oosmstaxable"></b-form-input>
                                </td>
                                <td>
                                    <b-form-input size="sm" type="number"
                                                  v-model="salary.data.current.res_oosms"></b-form-input>
                                </td>
                            </tr>
                            <tr>
                                <td>Взносы ОСМС</td>
                                <td>
                                    <b-form-input size="sm" type="number"
                                                  v-model="salary.data.current.res_vosmstaxable"></b-form-input>
                                </td>
                                <td>
                                    <b-form-input size="sm" type="number"
                                                  v-model="salary.data.current.res_vosms"></b-form-input>
                                </td>
                            </tr>
                            </tbody>
                        </table>

                    </div>
                    <div class="col-md-12">
                        <h5>Вычеты</h5>
                        <table class="table table-bordered table-sm">
                            <tbody>
                            <tr>
                                <th>Наименование</th>
                                <th>Стандартный вычет</th>
                                <th>Прочие вычеты</th>
                                <th>Остаток вычета 882МРП</th>
                                <th>Сумма вычетов</th>
                                <th>Перенос вычета с прошлого периода</th>
                                <th>Неиспользованный вычет в этом месяце</th>
                            </tr>
                            <tr>
                                <td>Вычет по ИПН</td>
                                <td>
                                    <b-form-input size="sm" type="number"
                                                  v-model="salary.data.current.recoupmentipn_standard"></b-form-input>
                                </td>
                                <td>
                                    <b-form-input size="sm" type="number"
                                                  v-model="salary.data.current.recoupmentipn_other"></b-form-input>
                                </td>
                                <td>
                                    <b-form-input size="sm" type="number"
                                                  v-model="salary.data.current.recoupmentipn_standard2"></b-form-input>
                                </td>
                                <td>
                                    <b-form-input size="sm" type="number"
                                                  v-model="salary.data.current.recoupmentipn"></b-form-input>
                                </td>
                                <td>
                                    <b-form-input size="sm" type="number"
                                                  v-model="salary.data.current.recoupmentlastipn"></b-form-input>
                                </td>
                                <td>
                                    <b-form-input size="sm" type="number"
                                                  v-model="salary.data.current.res_ipnexcess"></b-form-input>
                                </td>
                            </tr>
                            </tbody>
                        </table>

                    </div>

                </div>
                <template v-slot:modal-footer="{cancel}">
                    <b-button variant="primary" size="sm" @click="regSalary('save')"><span class="mdi mdi-content-save"></span> Сохранить
                    </b-button>
                    <b-button variant="secondary" size="sm" @click="cancel()"><span class="mdi mdi-close"></span> Закрыть
                    </b-button>
                </template>
            </b-modal>

            <ControlPanel :card="false" :icon="'mdi mdi-view-list'" :title="'Начисления заработной платы'" :links="links" premium="true">
              <template v-slot:left v-if="user.subscribe_type == 'premium'">
                <div class="mb-3">
                  <b-input-group size="sm" prepend="Период">

                    <Enums :key="'month' + locale" :type="'enum'" :name="'monthsquarters'" v-model="salary.month"
                           @change="regSalary()"></Enums>

                    <Enums :key="'year' + locale" :type="'enum'" :name="'years'" v-model="salary.year"
                           @change="regSalary()"></Enums>
                  </b-input-group>
                </div>
              </template>


              <b-dropdown size="sm" class="mr-1" variant="dark">
                <template v-slot:button-content><span class="mdi mdi-printer"></span> Печать документов</template>
                <b-dropdown-item v-b-modal.modal-salary-rv>Расчетная ведомость</b-dropdown-item>
                <b-dropdown-item v-b-modal.modal-salary-paysheet :disabled="buttons.paysheet.disabled">Платежная ведомость
                </b-dropdown-item>
              </b-dropdown>


              <Enums class="mr-sm-1" :key="'type' + locale" :type="'enum'" :name="'salaryfeature'" v-model="params.feature"
                     @change="regSalary()"></Enums>

              <SelectOrg class="mr-sm-1" :name="'orgs'" :table="'reg_organizations'"
                         :fields="['name']"></SelectOrg>

              <SelectGroup class="mr-sm-1" v-model="params.group"></SelectGroup>

              <b-form-select class="mr-sm-1" size="sm" v-model="params.worker" @change="regSalary()"
                             :options="workers"></b-form-select>




            </ControlPanel>

            <div class="container-fluid" v-if="user.registered && !user.subscribe_expired">
                <div class="row">
                    <div class="col-md-12">

                        <table class="table table-sm table-bordered table-hover table-14">
                            <tbody>
                            <tr class="bg-light">
                              <th rowspan="2">№</th>
                                <th rowspan="2">
                                    <b-form-checkbox v-model="selectAllTrigger" @change="selectAll(salary.data.list, selectAllTrigger)"
                                                     value="1"
                                                     unchecked-value="0"></b-form-checkbox>
                                </th>
                                <th rowspan="2"></th>
                                <th rowspan="2">Месяц</th>
                                <th rowspan="2">Год</th>
                                <th rowspan="2">Тип документа</th>
                                <th rowspan="2">Ф.И.О. сотрудника</th>
                                <th rowspan="2">ИИН</th>
                                <th colspan="3">Начисление</th>
                                <th rowspan="2">Действия</th>
                            </tr>
                            <tr class="bg-light">
                                <th>Оклад</th>
                                <th>На руки</th>
                                <th>Работодатель</th>

                            </tr>
                            <template v-if="typeof salary.data.list != 'undefined'">
                                <template v-for="(item, index) in salary.data.list">
                                    <tr :class="rowParams(item.manual_edited).class" :key="index" v-b-tooltip.hover
                                        :title="rowParams(item.manual_edited).title">
                                      <td>{{ index + 1 }}</td>
                                        <td>
                                            <b-form-checkbox v-model="selected[index]" :value="item.id" unchecked-value="0"></b-form-checkbox>
                                        </td>
                                        <td>
                                            <span :class="rowParams(item.manual_edited).icon"></span>
                                        </td>
                                        <td>{{ getMonthName(item.month) }}</td>
                                        <td>{{ item.year }}</td>
                                        <td>
                                            <Feature :feature="item.feature"></Feature>
                                        </td>

                                        <td>{{ item.last_name + ' ' + item.first_name + ' ' + item.middle_name }}</td>
                                        <td>{{ item.iin }}</td>
                                        <td>{{ item.res_sum }}</td>
                                        <td>{{ item.res_worker }}</td>
                                        <td>{{ item.res_employer }}</td>
                                        <td>
                                            <b-button class="mr-1" v-if="item.feature != 'merged'" @click="regSalary('edit', item.id)"
                                                      variant="success" size="sm"><span
                                                    class="mdi mdi-file-document-edit"></span> Редактировать
                                            </b-button>
                                            <b-button v-if="item.feature != 'merged'" @click="regSalary('erase', item.id)" variant="danger"
                                                      size="sm"><span
                                                    class="mdi mdi-delete"></span> Удалить
                                            </b-button>
                                        </td>
                                    </tr>
                                </template>

                            </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <Premium v-else />
        </div>

</template>


<script>
import Enums from "@/components/base/Enums";
import Salarysheet from "@/components/print/Salarysheet";
import Paysheet from "@/components/print/Paysheet";
import ControlPanel from "@/components/base/ControlPanel"
import SelectOrg from "@/components/base/SelectOrg";
import SelectGroup from "@/components/base/SelectGroup";
import Feature from "@/components/base/Feature";
import Premium from "@/components/base/Premium"
import {mapGetters} from "vuex";

export default {
  name: 'SalaryRegister',
  components: {
    Enums, Salarysheet, Paysheet, ControlPanel, SelectOrg, SelectGroup, Feature, Premium
  },
  data: function () {
    return {
      links: [
        {name: 'Калькулятор заработной платы', link: '/', icon: 'mdi mdi-calculator'},
      ],
      excel: {
        fields: {
          'Год': 'year',
          'Месяц': 'month',
          'Фамилия': 'last_name',
          'Имя': 'first_name',
          'Отчество': 'middle_name',
          'Должность': 'workerfunction',
          'ИИН': 'iin',
          'Дней': 'days',
          'Часов': 'hours',
          'Начислено': 'res_sum',
          'Удержано': 'res_deduction',
          'На руки': 'res_worker',
          'Затраты работодателя': 'res_employer',
          'Вычеты': 'recoupmentipn',
          'Корректировка 90%': 'res_adjustment',
          'ОПВ': 'res_opv',
          'ОПВР': 'res_opvr',
          'ОППВ': 'res_oppv',
          'ИПН': 'res_ipn',
          'СН': 'res_sn',
          'СО': 'res_so',
          'ВОСМС': 'res_vosms',
          'ООСМС': 'res_oosms',

        }
      },
      buttons: {
        paysheet: {
          disabled: false
        },
        paysalary: {
          disabled: true
        }
      },
      selectAllTrigger: '0',
      selected: [],
      fields: {
        month: 1,
        workername: 1,
        workerfunction: 1,
        iin: 1,
        dh: 1,
        sum: 1,
        deduction: 1,
        worker: 1,
        employer: 1,
        recoupment: 1,
        adjustment: 1,
        opv: 1,
        opvr: 1,
        oppv: 1,
        ipn: 1,
        sn: 1,
        so: 1,
        oosms: 1,
        vosms: 1,
        amount: 1,
        merge: 0,
        taxable: 0
      },
      params: {
        org: true,
        worker: 0,
        group: 0,
        feature: ''
      },
      showWorkers: false
    }
  },
  methods: {
    rowParams: function (mode) {
      var params = {
        class: '',
        title: 'Рассчитано при помощи калькулятора',
        icon: 'mdi mdi-calculator'
      };
      if (mode) {
        params.class = 'bg-warning text-danger';
        params.title = 'Отредактировано вручную. Могут иметься расхождения сумм начислений и удержаний с результатами расчёта. Рекомендуется удалить этот расчет и пересчитать заново';
        params.icon = 'mdi mdi-hand-front-left';
      }

      return params;
    },
    selectAll: function (arr, val) {
      this.selected = [];
      switch (val) {
        case '1':
          for (var i = 0; i < arr.length; i++) {
            this.selected.push(arr[i].id);
          }
          break;
        case '0':

          break;
      }

    },
    itemSelected: function (arr) {
      arr = arr.filter(function (x) {
        return x !== '0' && x !== 0 && x !== null;
      });
      return arr;
    },
    regSalary: function (mode, id) {
      this.$store.commit('wait', {state: true, name: 'Данные по зарплате'});
      this.salary.month == '0' ? this.buttons.paysheet.disabled = true : this.buttons.paysheet.disabled = false;
      this.$http
          .post(this.$apiold, {
            task: 'salary-register',
            mode: mode,
            id: id,
            orgid: this.org.id,
            merge: this.fields.merge,
            /*year: this.salary.year,
            month: this.salary.month,
            data: this.salary.data.current,

             */
            data: this.salary,
            params: this.params
          })
          .then(response => {
            this.$store.commit('wait', {state: false});
            this.$store.commit('user', response.data.user);

            this.$store.commit('salaryChange', response.data.salary);

            if (response.data.modal) {
              this.$bvModal.show('modal-salary');
            } else {
              this.$bvModal.hide('modal-salary');
            }

            // Сообщения
            this.$store.commit('alert', response.data.messages);
          });
    }
  },
  created: function () {
    this.regSalary();
  },
  computed: {
    ...mapGetters({
      org: 'org',
      workers: 'workersEnum',
      user: 'user',
      salary: 'salary',
      changedRegister: 'changedRegister'
    })
  },
  watch: {
    'params.group': function () {
      this.regSalary();
      //this.salaryInit();
    },
    'fields.merge': function () {
      this.regSalary();
      //this.salaryInit();
    },
    changedRegister() {
      this.regSalary();
      //this.salaryInit();
    },
    salary: {
      handler: function () {
        this.regSalary();
        //this.salaryInit();
      },
      deep: false
    },
    org() {
      this.params.worker = 0;
      this.regSalary();
    },
    selected: {
      handler: function () {
        if (this.itemSelected(this.selected).length > 0 && (this.salary.month != '0' || this.salary.month != '1q' || this.salary.month != '2q' || this.salary.month != '3q' || this.salary.month != '4q')) {
          this.buttons.paysalary.disabled = false
        } else {
          this.buttons.paysalary.disabled = true
        }
      },
      deep: true
    }
  }
}
</script>


<style>

</style>
